/**
 * Base class for all syntax errors.
 */
export abstract class SyntaxError extends Error {}

/**
 * Thrown when the lexer cannot tokenize the query.
 */
export class TokenizingError extends SyntaxError {}

/**
 * Thrown when the parser cannot parse the query.
 */
export class ParsingError extends SyntaxError {}
